module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-shadow box-shadow--big"
  }, [_c('div', {
    staticClass: "helper__wrapper"
  }, [_c('h5', {
    staticClass: "mb-3"
  }, [_vm._v(_vm._s(_vm.$t('SPECIFY_SCAR_TYPE')))]), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [_c('label', {
    staticClass: "fake-label",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.s3q7_typeVal),
      expression: "s3q7_typeVal"
    }],
    staticClass: "custom-input",
    attrs: {
      "type": "radio",
      "value": "OPARZENIE",
      "name": "scars-on-breast"
    },
    domProps: {
      "checked": _vm._q(_vm.s3q7_typeVal, "OPARZENIE")
    },
    on: {
      "change": [function($event) {
        _vm.s3q7_typeVal = "OPARZENIE"
      }, function($event) {
        return _vm.updateType(false)
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-container"
  }, [_vm._v(_vm._s(_vm.$t('BURN')))]), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('label', {
    staticClass: "fake-label",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.s3q7_typeVal),
      expression: "s3q7_typeVal"
    }],
    staticClass: "custom-input",
    attrs: {
      "type": "radio",
      "value": "URAZ",
      "name": "scars-on-breast"
    },
    domProps: {
      "checked": _vm._q(_vm.s3q7_typeVal, "URAZ")
    },
    on: {
      "change": [function($event) {
        _vm.s3q7_typeVal = "URAZ"
      }, function($event) {
        return _vm.updateType(false)
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-container"
  }, [_vm._v(_vm._s(_vm.$t('INJURY')))]), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('label', {
    staticClass: "fake-label",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.s3q7_typeVal),
      expression: "s3q7_typeVal"
    }],
    staticClass: "custom-input",
    attrs: {
      "type": "radio",
      "value": "INNY",
      "name": "scars-on-breast"
    },
    domProps: {
      "checked": _vm._q(_vm.s3q7_typeVal, "INNY")
    },
    on: {
      "change": [function($event) {
        _vm.s3q7_typeVal = "INNY"
      }, function($event) {
        return _vm.updateType(true)
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-container"
  }, [_vm._v(_vm._s(_vm.$t('OTHER_WHAT')))]), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), (_vm.showValueInput) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.s3q7_typeDescription),
      expression: "s3q7_typeDescription"
    }],
    staticClass: "el-input__inner el-input__inner--small",
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "placeholder": _vm.$t('INSERT_TYPE'),
      "type": "text"
    },
    domProps: {
      "value": (_vm.s3q7_typeDescription)
    },
    on: {
      "change": function($event) {
        return _vm.updateTypeDescription()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.s3q7_typeDescription = $event.target.value
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('h5', {
    staticClass: "mb-3"
  }, [_vm._v(_vm._s(_vm.$t('SPECIFY_SIZE_AND_LOCATION')))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-8 el-col-sm-offset-4 mt-3 mb-4"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "placeholder": _vm.$t('INSERT_DOTS')
    },
    on: {
      "change": _vm.updateDescription
    },
    model: {
      value: (_vm.s3q7_description),
      callback: function($$v) {
        _vm.s3q7_description = $$v
      },
      expression: "s3q7_description"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center mt-0 mb-3 mr-3"
  }, [_c('button', {
    staticClass: "w160 app-btn app-btn--small app-btn-primary"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('SAVE')) + "\n            ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2dcc28e8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/main-survey/helpers/scars-on-breast.vue
// module id = 1180
// module chunks = 0